import parse from "html-react-parser";
import React from "react";

import { PrimaryButton } from "_components/atoms/button";
import Typography        from "_components/atoms/typography";

import ProgressOptions from "../progressOptions";
import StepperHeader   from "../stepperHeader";

import useStyles from "./styles";

const StepTwo = ( { type, monetisationData, currentStep, totalSteps, stepData, seperatorText, toggleFeedback } ) => {

	const { isRejected, modalState, nextApprovalDate } = monetisationData;
	const { title, description, options, options1 }    = stepData;
	const showApprovalDate                             = modalState === 1;
	const isRejectedF                                  = isRejected;
	const { classes }                                  = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.stepTwoWrapper }>

			<StepperHeader
				currentStep       = { currentStep }
				isRejected        = { isRejectedF && modalState === 0 }
				nextApprovalDate  = { nextApprovalDate }
				showApprovalDate  = { showApprovalDate }
				title             = { title }
				totalSteps        = { totalSteps }
			/>

			{description && (
				<Typography
					title     = { parse ( description ) }
				/>
			)}

			{( isRejectedF && modalState === 0 ) && (
				<PrimaryButton
					className = { classes.rejectedButton }
					onClick   = { toggleFeedback }
					size      = "small"
					title     = { "View Feedback" }
				/>
			)}

			{type === "reels" && (
				<ProgressOptions
					options       = { options }
					options1      = { options1 }
					seperatorText = { seperatorText }
				/>
			)}

		</div>

	);
};

export default StepTwo;

